import { StyleSheet } from 'aphrodite';
import { borderColor, destructive, titles } from '../../../../web/styles/colors';
import { CssSelectors } from '../../../../web/styles/styles';

export const styleSheet = StyleSheet.create({
	container: {
		display: 'flex',
		flexDirection: 'column',
		height: '100%',
		margin: '0 auto',
	},
	content: {
		display: 'flex',
		flex: 1,
		minHeight: 0, // Important for proper flex behavior
		position: 'relative',
	},
	leftPanel: {
		flex: 1,
		overflowY: 'auto',
		padding: 20,
		borderRight: `1px solid ${borderColor}`,
		minWidth: 0, // Important for proper flex behavior
	},

	rightPanel: {
		flex: 1,
		overflowY: 'auto',
		padding: 20,
		minWidth: 0, // Important for proper flex behavior
	},
	footer: {
		padding: '20px 0',
		display: 'flex',
		justifyContent: 'center',
		borderTop: `1px solid ${borderColor}`,
		backgroundColor: 'white',
		// Ensure footer stays at bottom
		marginTop: 'auto',
	},
	header: {
		alignItems: 'flex-start',
		borderBottom: '1px solid #D8D8D8',
		boxSizing: 'border-box',
		color: titles,
		display: 'flex',
		fontSize: 18,
		justifyContent: 'center',
		marginBottom: 30,
		paddingBottom: 30,
		...CssSelectors.allDescendants(
			{
				// required to override default styles...adding className was not enough
				height: 'auto',
			},
			'.contacts-table-active-searches-list'
		),
	},
	headerLabel: {
		marginRight: 20,
	},
	headerTag: {
		fontSize: 12,
		height: 'auto',
		margin: 2,
		padding: '5px 10px',
		...CssSelectors.allChildren({
			margin: 0,
		}),
	},
	headerTagExcludeOp: {
		background: destructive,
	},
	pointDown: {
		transform: 'rotateZ(90deg)',
	},
	pointUp: {
		transform: 'rotateZ(270deg)',
	},
	searchesContainer: {
		maxWidth: 600,
	},
	tagTokenPrefix: {
		color: '#858585',
		fontSize: 14,
	},
	tagTokenRemoveButton: {
		alignItems: 'center',
		display: 'flex',
		justifyContent: 'center',
		marginLeft: 10,
	},
	tagTokenRemoveButtonIcon: {
		marginLeft: 10,
	},
	tagTokensAdvancedSearchButton: {
		fontSize: 14,
	},
	tokenContainer: {
		maxHeight: 'unset',
	},
	triggerText: {
		marginRight: 10,
	},
	usersColumn: {
		minWidth: 400,
	},
});
